module.exports = __webpack_public_path__ + "img/placeholder.6e08298c.png";